'use client';

import React from 'react';
import Link from 'next/link';
import { Home, User, Briefcase, FileText, HelpCircle, Phone, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BlogNavigationProps {
  showBackButton?: boolean;
  backText?: string;
  backHref?: string;
}

export default function BlogNavigation({ 
  showBackButton = true, 
  backText = "Zurück zum Blog", 
  backHref = "/blog" 
}: BlogNavigationProps) {
  const navigationItems = [
    { href: "/", icon: Home, label: "Startseite", description: "Zur Hauptseite" },
    { href: "/#about", icon: User, label: "Über uns", description: "Über Stella Lobzhanidze" },
    { href: "/#services", icon: Briefcase, label: "Leistungen", description: "Unsere Behandlungen" },
    { href: "/blog", icon: FileText, label: "Blog", description: "Alle Blog-Artikel" },
    { href: "/#faq", icon: HelpCircle, label: "FAQ", description: "Häufige Fragen" },
    { href: "/#footer", icon: Phone, label: "Kontakt", description: "Kontaktinformationen" },
  ];

  return (
    <div className="bg-white border-b border-gray-200 py-4">
      <div className="container mx-auto px-4">
        {/* Back Button */}
        {showBackButton && (
          <div className="mb-4">
            <Link href={backHref}>
              <Button variant="ghost" className="text-gray-600 hover:text-brand-primary">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {backText}
              </Button>
            </Link>
          </div>
        )}

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {navigationItems.map((item) => (
            <Link key={item.href} href={item.href}>
              <div className="group p-4 bg-gray-50 hover:bg-brand-primary/5 rounded-lg border border-gray-200 hover:border-brand-primary/20 transition-all duration-200 cursor-pointer">
                <div className="flex flex-col items-center text-center space-y-2">
                  <item.icon className="w-6 h-6 text-brand-primary group-hover:text-brand-primary-dark transition-colors" />
                  <div>
                    <div className="font-medium text-gray-900 group-hover:text-brand-primary transition-colors">
                      {item.label}
                    </div>
                    <div className="text-xs text-gray-500 group-hover:text-brand-primary/70 transition-colors">
                      {item.description}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
} 
